import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { CraftMarquee } from './components/CraftMarquee';
import { WhatsInside } from './components/WhatsInside';
import { Mechanism } from './components/Mechanism';
import { FuturePaced } from './components/FuturePaced';
import { PurchaseSection } from './components/PurchaseSection';
import { Guarantee } from './components/Guarantee';
import { Bonuses } from './components/Bonuses';
import { Reviews } from './components/Reviews';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { StickyCta } from './components/StickyCta';
import { craftsAnimals, craftsMachines } from './data/crafts';
export function App() {
  return <div className="w-full overflow-x-hidden bg-paper font-sans text-ink" data-id="element-0" data-mp="2wi5m1f302hnq">
      <main data-id="element-1" data-mp="28sl4n0mhvsgk">
        {/* 1 + 2 — Hero promise and large product visual */}
        <Hero data-id="element-2" data-mp="23ujkecdc1n3i" />

        {/* 3 — Pain */}
        <PainSection data-id="element-3" data-mp="23ti7e2craqj5" />

        {/* 4 — Auto-scrolling carousel #1 */}
        <section aria-label="Paper craft animals you can print and build" className="bg-paper pb-4 pt-14 sm:pt-20" data-id="element-4" data-mp="3ijfu9xduvsdk">
          <p className="mb-6 px-5 text-center font-display text-[12px] font-extrabold uppercase tracking-[0.22em] text-brand" data-id="element-5" data-mp="3mjg8bgx1m1k3">
            A few of the 1,200+ projects
          </p>
          <CraftMarquee items={craftsAnimals} direction="left" speed={56} label="Animals and creatures included in the kit" data-id="element-6" data-mp="5ggxfcks0yi" />
        </section>

        {/* 5 — What's inside */}
        <WhatsInside data-id="element-7" data-mp="33nq5jrhad155" />

        {/* 6 — Mechanism */}
        <Mechanism data-id="element-8" data-mp="38lrp0dimj2h5" />

        {/* 7 — Auto-scrolling carousel #2 */}
        <section aria-label="Paper craft vehicles, robots and worlds you can print and build" className="bg-paper pb-6 pt-2 sm:pb-10" data-id="element-9" data-mp="38kgkucl9nspi">
          <p className="mb-6 px-5 text-center font-display text-[12px] font-extrabold uppercase tracking-[0.22em] text-brand" data-id="element-10" data-mp="nvj179a902mk">
            Something different to build almost every day
          </p>
          <CraftMarquee items={craftsMachines} direction="right" speed={56} label="Vehicles, robots and buildings included in the kit" data-id="element-11" data-mp="36hzxgtw5a5z" />
        </section>

        {/* 8 — Future-paced benefits */}
        <FuturePaced data-id="element-12" data-mp="d4nv7fl6zi1v" />

        {/* 9 + 10 — Purchase section with launch urgency and countdown */}
        <PurchaseSection data-id="element-13" data-mp="85l1granwy97" />

        {/* 11 — Guarantee */}
        <Guarantee data-id="element-14" data-mp="8649ngaig8a1" />

        {/* 12 — Bonuses */}
        <Bonuses data-id="element-15" data-mp="3gl4q1d0e1shx" />

        {/* 13 — Reviews */}
        <Reviews data-id="element-16" data-mp="3glwfs77b0w0a" />

        {/* 14 — FAQ */}
        <Faq data-id="element-17" data-mp="3bmjsjlcitmx6" />

        {/* 15 — Final CTA */}
        <FinalCta data-id="element-18" data-mp="3bnuudfmeokln" />
      </main>

      

      <StickyCta data-id="element-19" data-mp="3qb7k7gj8xchu" />
    </div>;
}